
export const generateLink = (andTag: string, action?) => {
	const params =
		typeof window !== 'undefined' ? Object.fromEntries(new URLSearchParams(window.location.search).entries()) : {};
	if (action) {
		params.a = action;
	}
	const a = `https://now.andme.org/&${andTag}?${Object.entries(params)
		.map(([key, value]) => `${key}=${value}`)
		.join('&')}`;

	return a;
};
export default generateLink;
